import React from 'react';
import {RootNavigator} from './navigation/RootNavigation';
import {ConfirmationModalProvider} from 'context/ConfirmModalContext';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import {store, persistor} from './redux/store';
import {ToastProvider} from 'context/ToastContext';
import 'index.css'; // for some web specific styling that cant be done using react native styles
import {SafeAreaProvider, initialWindowMetrics} from 'react-native-safe-area-context';


// Main App Component
const App: React.FC = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SafeAreaProvider initialMetrics={initialWindowMetrics}>
          <ToastProvider>
            <ConfirmationModalProvider>
              <RootNavigator />
            </ConfirmationModalProvider>
          </ToastProvider>
        </SafeAreaProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
